export const dialogDisplayed = 'copy_and_link_action_click';
export const dialogCanceled = 'copy_and_link_cancel_click';
export const dialogSubmitted = 'copy_and_link_submit_click';
